function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-2-2h16v16H-2z"
}), React.createElement("path", {
  fill: "#D14B08",
  d: "M6.906 1.25l3.844 3.844c.316.315.397.462.45.639a.909.909 0 010 .534c-.053.177-.134.324-.45.64L6.906 10.75c-.315.316-.462.397-.639.45a.909.909 0 01-.534 0c-.177-.053-.324-.134-.64-.45L1.25 6.906C.934 6.591.853 6.444.8 6.267a.909.909 0 010-.534c.053-.177.134-.324.45-.64L5.094 1.25c.315-.316.462-.397.639-.45a.909.909 0 01.534 0c.177.053.324.134.64.45z"
}));

var SvgBulletShape1 = function SvgBulletShape1(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0yLTJoMTZ2MTZILTJ6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI0QxNEIwOCIgZD0iTTYuOTA2IDEuMjVsMy44NDQgMy44NDRjLjMxNi4zMTUuMzk3LjQ2Mi40NS42MzlhLjkwOS45MDkgMCAwIDEgMCAuNTM0Yy0uMDUzLjE3Ny0uMTM0LjMyNC0uNDUuNjRMNi45MDYgMTAuNzVjLS4zMTUuMzE2LS40NjIuMzk3LS42MzkuNDVhLjkwOS45MDkgMCAwIDEtLjUzNCAwYy0uMTc3LS4wNTMtLjMyNC0uMTM0LS42NC0uNDVMMS4yNSA2LjkwNkMuOTM0IDYuNTkxLjg1MyA2LjQ0NC44IDYuMjY3YS45MDkuOTA5IDAgMCAxIDAtLjUzNGMuMDUzLS4xNzcuMTM0LS4zMjQuNDUtLjY0TDUuMDk0IDEuMjVjLjMxNS0uMzE2LjQ2Mi0uMzk3LjYzOS0uNDVhLjkwOS45MDkgMCAwIDEgLjUzNCAwYy4xNzcuMDUzLjMyNC4xMzQuNjQuNDV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgBulletShape1 as ReactComponent };